module.exports = __webpack_public_path__ + "static/img/nav_bg.5737a809.png";